import { render } from "./ReportMessage.vue?vue&type=template&id=e1c9dea6&scoped=true"
import script from "./ReportMessage.vue?vue&type=script&lang=js"
export * from "./ReportMessage.vue?vue&type=script&lang=js"

import "./ReportMessage.vue?vue&type=style&index=0&id=e1c9dea6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c9dea6"]])

export default __exports__